var map = {
	"./11.svg": 385,
	"./14.svg": 386,
	"./15.svg": 387,
	"./16.svg": 388,
	"./17.svg": 389,
	"./18.svg": 390,
	"./19.svg": 391,
	"./2.svg": 392,
	"./20.svg": 393,
	"./21.svg": 394,
	"./22.svg": 395,
	"./23.svg": 396,
	"./24.svg": 397,
	"./25.svg": 398,
	"./28.svg": 399,
	"./29.svg": 400,
	"./30.svg": 401,
	"./31.svg": 402,
	"./33.svg": 403,
	"./34.svg": 404,
	"./35.svg": 405,
	"./36.svg": 406,
	"./37.svg": 407,
	"./39.svg": 408,
	"./4.svg": 409,
	"./40.svg": 410,
	"./6.svg": 411,
	"./7.svg": 412,
	"./8.svg": 413,
	"./9.svg": 414,
	"./unused icon/1.svg": 415,
	"./unused icon/10.svg": 416,
	"./unused icon/12.svg": 417,
	"./unused icon/13.svg": 418,
	"./unused icon/26.svg": 419,
	"./unused icon/27.svg": 420,
	"./unused icon/3.svg": 421,
	"./unused icon/32.svg": 422,
	"./unused icon/38.svg": 423,
	"./unused icon/5.svg": 424
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;


//////////////////
// WEBPACK FOOTER
// ./src/assets/units ^\.\/.*\.svg$
// module id = 99
// module chunks = 14